import layout from '@/layout'

export default {
  path: '/operation',
  component: layout,
  redirect: '/operation/upgradeManage',
  name: 'upgradeConfig',
  meta: {
    title: '运营设置',
    icon: 'setting-config'
  },
  children: [
    {
      path: '/operation/upgradeManage',
      redirect: '/operation/upgradeManage/applicationManage',
      meta: {
        title: '升级管理',
        icon: 'high-light'
      },
      children: [
        {
          path: '/operation/upgradeManage/applicationManage',
          component: () => import('@/views/operation/upgradeManage/upgrade-config'),
          meta: {
            title: '应用配置',
            icon: 'hunting-gear'
          }
        }
      ]
    }
  ]
}
